(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8556,1448],{

/***/ 72651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);











// env
var inBrowser = "object" !== "undefined";
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
var Dialog = function(props) {
    var animation = (props.animationType === "enter" ? props.enterAnimation : props.leaveAnimation) || props.animation;
    var className = "rodal-dialog rodal-".concat(animation, "-").concat(props.animationType);
    var CloseButton = props.showCloseButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "rodal-close",
        onClick: props.onClose,
        children: "Close"
    }) : null;
    var width = props.width, height = props.height, measure = props.measure, duration = props.duration, customStyles = props.customStyles;
    var style = {
        width: width + "%",
        minHeight: height + measure,
        animationDuration: duration + "ms",
        WebkitAnimationDuration: duration + "ms"
    };
    var mergedStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, style, customStyles);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: mergedStyles,
        className: className,
        children: [
            props.children,
            CloseButton
        ]
    });
};
var _Component;
var rodal = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(rodal, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(rodal);
    function rodal() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, rodal);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "state", {
            isShow: false,
            animationType: "leave"
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onKeyUp", function(event) {
            if (_this.props.closeOnEsc && event.keyCode === 27) {
                _this.props.onClose();
            }
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "animationEnd", function(event) {
            if (_this.state.animationType === "leave") {
                _this.setState({
                    isShow: false
                });
            } else if (_this.props.closeOnEsc) {
                _this.el.focus();
            }
            if (event.target === _this.el) {
                var onAnimationEnd = _this.props.onAnimationEnd;
                onAnimationEnd && onAnimationEnd();
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(rodal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.visible) {
                    this.enter();
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (!this.props.visible && nextProps.visible) {
                    this.enter();
                } else if (this.props.visible && !nextProps.visible) {
                    this.leave();
                }
            }
        },
        {
            key: "enter",
            value: function enter() {
                this.setState({
                    isShow: true,
                    animationType: "enter"
                });
                document.getElementsByTagName("html")[0].style.overflow = "hidden";
            }
        },
        {
            key: "leave",
            value: function leave() {
                this.setState(isIE9 ? {
                    isShow: false
                } : {
                    animationType: "leave"
                });
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.getElementsByTagName("body")[0].style.overflowY = "";
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref = this, props = ref.props, state = ref.state;
                var onClick = props.closeMaskOnClick ? props.onClose : null;
                var mask = props.showMask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rodal-mask",
                    style: props.customMaskStyles,
                    onClick: onClick
                }) : null;
                var style = {
                    display: state.isShow ? "block" : "none",
                    animationDuration: props.duration + "ms",
                    WebkitAnimationDuration: props.duration + "ms"
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: style,
                    className: "rodal rodal-fade-" + state.animationType + " " + props.className,
                    onAnimationEnd: this.animationEnd,
                    tabIndex: "-1",
                    ref: function(el) {
                        _this.el = el;
                    },
                    onKeyUp: this.onKeyUp,
                    children: [
                        mask,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                            animationType: state.animationType,
                            children: props.children
                        }))
                    ]
                });
            }
        }
    ]);
    return rodal;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "propTypes", {
    width: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    height: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
    ]),
    measure: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    visible: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showMask: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeOnEsc: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeMaskOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    animation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    enterAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    leaveAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    duration: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    customStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    customMaskStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    onAnimationEnd: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func)
});
// ...
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "defaultProps", {
    width: 100,
    height: 300,
    measure: "px",
    visible: false,
    showMask: true,
    closeOnEsc: false,
    closeMaskOnClick: true,
    showCloseButton: false,
    animation: "zoom",
    enterAnimation: "",
    leaveAnimation: "",
    duration: 300,
    className: "",
    customStyles: {},
    customMaskStyles: {}
});
/* harmony default export */ __webpack_exports__["Z"] = (rodal);


/***/ }),

/***/ 93992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalShowroomAds_ReasonModalHOC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/useClosePopupFromOutsideClick.js

function useClosePopupFromOutsideClick(referenceToDomElement, toggleClose, props) {
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var ref;
        if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(referenceToDomElement.current))) {
            e.stopPropagation();
            toggleClose(props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.toggleStatus);
        }
    };
}
/* harmony default export */ var utils_useClosePopupFromOutsideClick = (useClosePopupFromOutsideClick);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModal.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 20px;\n  margin-left: ",
        "rem;\n  transform: rotateZ(180deg);\n  margin-top: ",
        "rem;\n  box-shadow: 0px -6px 12px 2px rgb(0 0 0 / 30%);\n  ",
        ";\n\n  &:before {\n    content: '';\n    border-top: 10px solid white;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PointingArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PointingArrow",
    componentId: "sc-6444d3ae-0"
})(_templateObject(), function(props) {
    return props.ml || 0;
}, function(props) {
    return props.mt || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.translateX) && (props === null || props === void 0 ? void 0 : props.translateY) && "transform : translate(".concat(props === null || props === void 0 ? void 0 : props.translateX, "rem , ").concat(props === null || props === void 0 ? void 0 : props.translateY, "rem) rotate(180deg)");
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js





function ReasonModalHOC(props) {
    var elementReferenceForOutsideClick = (0,react.useRef)();
    var closePopupForParticularId = {
        id: props.id,
        toggleStatus: false
    };
    utils_useClosePopupFromOutsideClick(elementReferenceForOutsideClick, props.toggleAdReasonModal, closePopupForParticularId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointingArrow, {
                ml: props.ml,
                translateX: props.translateX,
                translateY: props.translateY,
                mt: props.mt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    zIndex: 1
                },
                ref: elementReferenceForOutsideClick,
                className: props.class,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(props.reasonModal, {})
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_ReasonModalHOC = (ReasonModalHOC);


/***/ }),

/***/ 18556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footers_Footer1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(95218);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(67313);
;// CONCATENATED MODULE: ./src/assets/svgExports/FlagIcon.js

var FlagIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10.44",
        height: "10.462",
        viewBox: "0 0 10.44 10.462",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Page-1",
            transform: "translate(0 0.05)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "_037---Waypoint-Flag",
                "data-name": "037---Waypoint-Flag",
                transform: "translate(0 -0.05)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Shape",
                        d: "M2.644,19.49l.192-.054a.348.348,0,0,0,.241-.429l-2.2-7.87a.435.435,0,0,0-.536-.3l-.025.007a.435.435,0,0,0-.3.536l2.2,7.87a.348.348,0,0,0,.429.241Z",
                        transform: "translate(0 -9.042)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Shape-2",
                        "data-name": "Shape",
                        d: "M15.693,5.9A8.333,8.333,0,0,1,13.777,4.58a.171.171,0,0,1-.049-.175A24.654,24.654,0,0,0,14.36,1.13c.022-.184-.077-.238-.182-.112C12.128,3.47,8.581.569,6.47,2.8a.719.719,0,0,1,.059.15L7.956,8.056c2.115-2.2,5.649.681,7.7-1.765.1-.126.124-.357.041-.393Z",
                        transform: "translate(-5.305 -0.95)"
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(35449);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/MobileReasonModal.js


function MobileReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex f12px pa18px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-section pb18px fw6",
                        children: "You are seeing this Ad because owner of this website is using the free version"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center pl18px pr18px black-90",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex f12px fw6",
                        children: [
                            "If you own this website ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "f12px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "remove-adsection pa12px fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_MobileReasonModal = (MobileReasonModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(93992);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(43955);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(15483);
;// CONCATENATED MODULE: ./src/components/BrandFooter/index.js














var BrandFooter = function(props) {
    var toggleAdReasonModal = function toggleAdReasonModal() {
        setShowAdInfo(!showAdInfo);
    };
    var renderMobileAds = function renderMobileAds() {
        var ref, ref1, ref2;
        return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf && ((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_mobile) && !(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* AdContainer */.g1, {
                paddingTop: 30,
                paddingBottom: 30,
                backgroundColor: "#000000",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-column digital-showroom__ads w-100 ph3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-100 bg-black-90 mb6px",
                            onClick: function() {
                                return setShowAdInfo(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex f12px o-50 mb6px white-90",
                                    children: "Why I am seeing this"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "digital-showroom__ads_footermt_-2px ml6px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                        size: 16,
                                        secondaryColor: "#838383"
                                    })
                                })
                            ]
                        }),
                        showAdInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                            toggleAdReasonModal: toggleAdReasonModal,
                            reasonModal: DigitalShowroomAds_MobileReasonModal,
                            class: "mobile-reason-modal",
                            ml: -1.21,
                            mt: 1.45,
                            translateX: 9.35,
                            translateY: -2.25
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gif-height pointer items-start",
                            onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_mobile,
                                width: 630,
                                height: 187
                            })
                        })
                    ]
                })
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var ref5 = (0,react.useState)(false), showAdInfo = ref5[0], setShowAdInfo = ref5[1];
    var shouldHideDSLogo = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Footer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : ref4.hide_ds_label;
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    var onPlayStoreIconClick = function() {
        window.open("https://download.digitalshowroom.app/download-cfe", "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "brand-footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "brand-footer__wrapper text-links",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__linkText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "brand-footer__linkText--href",
                            href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                            target: "_blank",
                            rel: "noreferrer",
                            children: "View Terms & Conditions"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__linkText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "brand-footer__linkText--href",
                            href: constants/* CANCELATION_AND_REFUND_POLICY_URL */.a6,
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Refunds & Cancellation"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__linkText flex flex-row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "brand-footer__linkText--href flex",
                            href: "https://forms.gle/E86rmFAD2GP9rL9f7",
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex pt2px mr6px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagIcon, {})
                                }),
                                "Report Store"
                            ]
                        })
                    })
                ]
            }),
            renderMobileAds(),
            !shouldHideDSLogo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "brand-footer__wrapper bg-pure-black-color",
                onClick: onPlayStoreIconClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__fadeText",
                        children: "Online store created using"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__BrandIcon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/images/bottom-app-logo.png",
                            loading: "lazy",
                            alt: "Brand App Logo"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BrandFooter = (BrandFooter);

// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(21448);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(85126);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
// EXTERNAL MODULE: ./src/components/DesignSystem/Footers/FooterStorePolicies/index.js
var FooterStorePolicies = __webpack_require__(81059);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/redux/actions/storePolicies.js
var actions_storePolicies = __webpack_require__(49784);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
;// CONCATENATED MODULE: ./src/components/FooterStoreInfo/index.js














var FooterStoreInfo = function(param) {
    var store = param.store, props = param.props;
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderLoginLogout = function renderLoginLogout() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer1-login-logout",
                onClick: toggleAuthModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer1-login-logout-button fw5 pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: 12
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                })
            })
        });
    };
    var authAndLogoutModal = function authAndLogoutModal() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        });
    };
    var renderSocialMediaProfileDetails = function renderSocialMediaProfileDetails() {
        var ref, ref1, ref2;
        if (!((ref = store.social_media_profile_details) === null || ref === void 0 ? void 0 : ref.media_count) || ((ref1 = store.social_media_profile_details) === null || ref1 === void 0 ? void 0 : ref1.media_count) < 1) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "footer-social-media-container",
            style: {
                marginTop: "-10px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    style: {
                        marginBottom: "14px"
                    },
                    children: "Follow us here"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-media-section flex space-between",
                    style: {
                        gap: "16px"
                    },
                    children: (ref2 = store.social_media_profile_details) === null || ref2 === void 0 ? void 0 : ref2.media_detail.map(function(profile) {
                        return profile.profile_url !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "social-media-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profile.profile_url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: profile.image_url,
                                    alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image"),
                                    height: 24,
                                    width: 24
                                })
                            })
                        }, profile.id) : null;
                    })
                })
            ]
        });
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        return {
            user: state.userReducer,
            storePolicies: state.storePolicyReducer.data
        };
    }), user = ref4.user, storePolicies = ref4.storePolicies;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref5 = (0,react.useState)(false), showLogoutConfirmation = ref5[0], setShowLogoutConfirmation = ref5[1];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var visitorLoginFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().visitorLoginFeatureStatus;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    (0,react.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length)) dispatch((0,actions_storePolicies/* getStorePolicies */.S)({
            store_id: storeData.store_id
        }));
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length
    ]);
    (0,react.useEffect)(function() {
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    var toggleAuthModal = function() {
        if (user === null || user === void 0 ? void 0 : user.isLogin) {
            toggleLogoutModal();
        } else {
            var ref;
            router.push((0,routes.getRoute)(routes.PATH.ORDERS, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var onCallBtnClick = function() {
        window.open("tel:".concat(storePhone), "_self");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authAndLogoutModal(),
            store && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "footerStoreInfo",
                style: {
                    backgroundImage: "url(/assets/images/footerInfo-bgImg.png)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "footerStoreInfo__name",
                        children: store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: isVisitorLoginVisible && renderLoginLogout()
                    }),
                    store.address && (store === null || store === void 0 ? void 0 : (ref1 = store.address) === null || ref1 === void 0 ? void 0 : ref1.visibility) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                        className: "footerStoreInfo__address",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "address",
                                loading: "lazy",
                                src: "/assets/images/3@2x.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: store === null || store === void 0 ? void 0 : store.address.address_1
                            })
                        ]
                    }),
                    !!storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "footerStoreInfo__phone",
                        onClick: onCallBtnClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "phone",
                                loading: "lazy",
                                src: "/assets/images/phone.png"
                            }),
                            storePhone
                        ]
                    }),
                    (store === null || store === void 0 ? void 0 : store.social_media_profile_details) && renderSocialMediaProfileDetails(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStorePolicies/* FooterStorePolicies */.p, {
                        storePolicies: storePolicies,
                        path: routes.PATH.STORE_POLICIES
                    }),
                    !(props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.payment_method_images_not_visible) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        style: {
                            display: "none"
                        },
                        className: "footerStoreInfo_paymentOption",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (0,getCustomCtaText/* default */.Z)("pay_after_cta")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/icons@2x.png",
                                alt: "payment options",
                                loading: "lazy"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FooterStoreInfo = (FooterStoreInfo);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Footers/Footer1/index.js





var Footer1 = function(props) {
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FooterStoreInfo, {
                store: storeData,
                props: props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BrandFooter, {})
        ]
    });
};
/* harmony default export */ var Footers_Footer1 = (Footer1);


/***/ }),

/***/ 81059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ FooterStorePolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86438);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79570);




var FooterStorePolicies = function(props) {
    return !props.storePolicies || props.storePolicies.length == 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottom_section), " flex flex-column items-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().store_policies), " flex justify-around w-100 f6"),
            children: props === null || props === void 0 ? void 0 : props.storePolicies.map(function(page) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    name: "page".concat(page.page_type),
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_nav),
                    onClick: function() {
                        return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__/* .handleRouteChangesOnClick */ .Z)(props === null || props === void 0 ? void 0 : props.path, {
                            page_type: page.page_type
                        });
                    },
                    children: page.page_name
                }, page.id);
            })
        })
    });
};


/***/ }),

/***/ 43955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Z5": function() { return /* binding */ AllCategorySection; },
/* harmony export */   "bu": function() { return /* binding */ AllCategoryButton; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "rV": function() { return /* binding */ MiddleBodyAdWrapper; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  display: flex;\n  max-width: 1600px;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 5;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: 3;\n  background: ",
        ";\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  background: #fff;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(50px);\n      }\n      to {\n        transform : translateX(-".concat(trasnlationDist - 50, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-81fe99c9-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
}, function(props) {
    return props.isBuilderMobile ? "100%" : "80%";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-81fe99c9-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-81fe99c9-2"
})(_templateObject2());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-81fe99c9-3"
})(_templateObject3());
var AllCategorySection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-81fe99c9-4"
})(_templateObject4());
var AllCategoryButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-81fe99c9-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var AdContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdContainer",
    componentId: "sc-81fe99c9-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor || "#FFFFFF";
}, function(props) {
    return props.paddingTop || 0;
}, function(props) {
    return props.paddingBottom || 0;
});
var MiddleBodyAdWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MiddleBodyAdWrapper",
    componentId: "sc-81fe99c9-7"
})(_templateObject7());


/***/ }),

/***/ 21448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20155);








function LogoutModal(props) {
    var showLogoutConfirmationModal = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return {
            showLogoutConfirmationModal: state.commonReducer.showLogoutConfirmationModal
        };
    }).showLogoutConfirmationModal;
    return _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_MOBILE_WIDTH */ .Cf ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoutDesktopModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        showLogoutConfirmationModal: showLogoutConfirmationModal || props.showLogoutConfirmation
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoutMobileModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        showLogoutConfirmationModal: showLogoutConfirmationModal || props.showLogoutConfirmation
    }));
}
function LogoutMobileModal(props) {
    var executeLogout = function() {
        props.executeLogout();
        props === null || props === void 0 ? void 0 : props.toggleLogoutModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            visible: props.showLogoutConfirmationModal,
            className: "mobile-center-modal margin-top-modal-0 !tw-z-[700]",
            animation: "slideUp",
            width: 85,
            height: 150,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "logout-modal-content-container flex flex-column !tw-z-[700]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center fw7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                color: "black",
                                fontSize: 16,
                                transform: "translate(10px , 11px)",
                                whiteSpace: "nowrap"
                            },
                            children: "Are you sure you want to Logout?"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row justify-end",
                        style: {
                            marginTop: 16,
                            transform: "translateY(24px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex no-container items-center justify-center bg-black-90 br4",
                                onClick: props === null || props === void 0 ? void 0 : props.toggleLogoutModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "white fw6",
                                    children: "No"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex yes-container items-center justify-center br4 bg-white-90",
                                onClick: executeLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "br4 black fw6",
                                    children: "Yes"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function LogoutDesktopModal(props) {
    var executeLogout = function() {
        props.executeLogout();
        props === null || props === void 0 ? void 0 : props.toggleLogoutModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            visible: props.showLogoutConfirmationModal,
            className: "bottom-modal",
            animation: "slideUp",
            width: 30,
            height: 150,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "logout-modal-content-container flex flex-column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            style: {
                                color: "black",
                                marginLeft: 10
                            },
                            children: "Are you sure you want to Logout?"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row justify-end mt4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex no-container items-center justify-center bg-black-90 br4",
                                onClick: props === null || props === void 0 ? void 0 : props.toggleLogoutModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "white fw6",
                                    children: "No"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex yes-container items-center justify-center br4 bg-white-90",
                                onClick: executeLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "br4 black fw6",
                                    children: "Yes"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (LogoutModal);


/***/ }),

/***/ 27560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFeatureLocks; }
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);



function useFeatureLocks() {
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            featureLocks: state.commonReducer.featureLocksData.featureLocks,
            storeData: state.storeReducer.store
        };
    }), featureLocks = ref.featureLocks, storeData = ref.storeData;
    var isEcommExpired = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (storeData === null || storeData === void 0 ? void 0 : storeData.subscription_flag) === _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .SUBSCRIPTION_FLAG.EXPIRED */ .NU.EXPIRED;
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.subscription_flag
    ]);
    var crrFeatureStatus = featureLocks["crr"];
    var couponsFeatureStatus = featureLocks["couponsVouchers"];
    var fbPixelFeatureStatus = featureLocks["fbPixel"];
    var googleAnalyticsFeatureStatus = featureLocks["googleAnalytics"];
    var googleTagFeatureStatus = featureLocks["gtm"];
    var installAppFeatureStatus = featureLocks["installApp"];
    var leadGenFeatureStatus = featureLocks["leadGen"];
    var visitorLoginFeatureStatus = featureLocks["visitorLogin"];
    var collectionsFeatureStatus = featureLocks["collections"];
    var notifyMeFeatureStatus = featureLocks["notifyMe"];
    var partialPaymentFeatureStatus = featureLocks["partialPayment"];
    var memberOnlyLoginFeatureStatus = featureLocks["memberOnlyLogin"];
    return {
        collectionsFeatureStatus: collectionsFeatureStatus,
        couponsFeatureStatus: couponsFeatureStatus,
        crrFeatureStatus: crrFeatureStatus,
        fbPixelFeatureStatus: fbPixelFeatureStatus,
        googleAnalyticsFeatureStatus: googleAnalyticsFeatureStatus,
        googleTagFeatureStatus: googleTagFeatureStatus,
        installAppFeatureStatus: installAppFeatureStatus,
        leadGenFeatureStatus: leadGenFeatureStatus,
        visitorLoginFeatureStatus: visitorLoginFeatureStatus,
        isEcommExpired: isEcommExpired,
        notifyMeFeatureStatus: notifyMeFeatureStatus,
        partialPaymentFeatureStatus: partialPaymentFeatureStatus,
        memberOnlyLoginFeatureStatus: memberOnlyLoginFeatureStatus
    };
}


/***/ }),

/***/ 99375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68037);
/* harmony import */ var src_utils_getContactDetails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60492);


var useStoreContactDetails = function() {
    var hideOwnerPhone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var storeData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return (0,src_utils_getContactDetails__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(storeData, true, hideOwnerPhone);
};
/* harmony default export */ __webpack_exports__["Z"] = (useStoreContactDetails);


/***/ }),

/***/ 68037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IU": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.IU; },
/* harmony export */   "Vn": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.Vn; },
/* harmony export */   "kF": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.kF; },
/* harmony export */   "u": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.u; },
/* harmony export */   "v9": function() { return /* reexport safe */ _reducers__WEBPACK_IMPORTED_MODULE_0__.v; },
/* harmony export */   "wm": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.wm; }
/* harmony export */ });
/* harmony import */ var _reducers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1532);
/* harmony import */ var _ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20155);




/***/ }),

/***/ 85126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ executeLogout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56173);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66162);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68060);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44541);
/**
 * common logout component. After logout
 * is initiated, if successful
 * reroute to product
 */ 





function executeLogout() {
    var ref, ref1, ref2;
    var storeData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer) === null || ref === void 0 ? void 0 : ref.store;
    var cartData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
    localStorage.clear();
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .setLogout */ .wt)());
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cartData), {
        items: [],
        store_offer: {},
        payment_offer: {}
    })));
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .removeSelectedAddress */ .uz)());
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .saveAddressList */ .Af)({
        addressList: [],
        defaultAddress: {}
    }));
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)((storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.custom_theme_flag) ? _routes__WEBPACK_IMPORTED_MODULE_2__.PATH.PRODUCT : _routes__WEBPACK_IMPORTED_MODULE_2__.PATH.SHOP, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
}


/***/ }),

/***/ 36623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);



/** This utility function returns custom cta texts, certain labels based on is the store deliverying orders or
 * booking services
 * @param {string} type -> type of text you want
 * @return {string} -> text you wanted
 */ var getCustomCtaText = function(type) {
    var _store = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store, theme = _store.theme, services = _store.services;
    var isStoreServiceBased = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED && (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() != _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    var isExtraChargeForCODActive = (services === null || services === void 0 ? void 0 : services.cod_charge_flag) > _constants__WEBPACK_IMPORTED_MODULE_2__/* .COD_CHARGE_TYPE.FREE */ .VV.FREE;
    var getBillConfirmedHeading = function() {
        switch((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)()){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED:
                return "Order placed successfully!";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B:
                return "Request submitted Successfully";
            default:
                return "Booked Successfully";
        }
    };
    var getBillOrderIdLabel = function() {
        var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
        switch(cart.order_type){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE:
                return "Your Booking ID:";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.B2B */ .Jm.B2B:
                return "Your Request ID:";
            default:
                return "Your Order ID:";
        }
    };
    switch(type){
        case "my_orders_cta":
            var ref, ref1;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.my_orders) return theme === null || theme === void 0 ? void 0 : (ref1 = theme.cta_config) === null || ref1 === void 0 ? void 0 : ref1.my_orders;
            else if (isStoreServiceBased) return "My Bookings";
            else return "My Orders";
        case "bill_confirm_heading":
            return getBillConfirmedHeading();
        case "placing_order_cta":
            if (isStoreServiceBased) return "Booking your Service";
            else return "Placing Your Order";
        case "buy_now_cta":
            var ref2, ref3;
            if (theme === null || theme === void 0 ? void 0 : (ref2 = theme.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_cta) return theme === null || theme === void 0 ? void 0 : (ref3 = theme.cta_config) === null || ref3 === void 0 ? void 0 : ref3.pdp_cta;
            else if (isStoreServiceBased) return "Book Now";
            else "Buy NOW";
        case "empty_cart_cta":
            return isStoreServiceBased ? "Book Now" : "Shop Now";
        case "banner_cta":
            var ref4, ref5;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.banner_cta) return theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.banner_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Shop Now";
        case "order_instructions_label":
            if (isStoreServiceBased) return "Booking Instructions";
            else return "Order Instructions";
        case "cart_cta":
            var ref6, ref7;
            if (theme === null || theme === void 0 ? void 0 : (ref6 = theme.cta_config) === null || ref6 === void 0 ? void 0 : ref6.postpaid_cart_cta) return theme === null || theme === void 0 ? void 0 : (ref7 = theme.cta_config) === null || ref7 === void 0 ? void 0 : ref7.postpaid_cart_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Place Order";
        case "item_total_label":
            if (isStoreServiceBased) return "Total";
            else return "Item Total";
        case "order_summary_heading":
            if (isStoreServiceBased) return "Summary";
            else return "Order Summary";
        case "item_details_heading":
            if (isStoreServiceBased) return "Details";
            else return "Item Details";
        case "widget_cta":
            if (isStoreServiceBased) return "Book Now";
            else return "Explore Now";
        case "cart_confirm_cta":
            {
                var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
                var isOrderServiceType = cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE;
                if (isOrderServiceType) return "Pay after service";
                else if (cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                else return "Pay on Pickup";
            }
        case "pay_after_cta":
            if (isStoreServiceBased) return "Pay after Service using";
            else return "Pay on Delivery / Pickup using";
        case "other_payment_modes_cta":
            if (isStoreServiceBased) return "Pay after service";
            else {
                var _orderDetails = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().orderReducer.orderDetails, prepaid_flag = _orderDetails.prepaid_flag, order_type = _orderDetails.order_type;
                if (prepaid_flag === 1) {
                    if (order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                    else return "Pay On Pick Up";
                } else return "Cash On Delivery";
            }
        case "bill_order_id":
            {
                return getBillOrderIdLabel();
            }
        case "order_list_heading":
            return isStoreServiceBased ? "My Bookings" : "My Orders";
        default:
            return "";
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getCustomCtaText);


/***/ }),

/***/ 79570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44541);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ }),

/***/ 95218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ removeDsAdsRouteLink; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);

function removeDsAdsRouteLink() {
    window.open(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK */ .gr.COMMON_REDIRECTION_LINK, "_blank");
}


/***/ }),

/***/ 86438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottom_section":"FooterStorePolicies_bottom_section__Q64j2","footer__bottom-text":"FooterStorePolicies_footer__bottom-text__Cfylc","policy-nav":"FooterStorePolicies_policy-nav__u8EJg","store_policies":"FooterStorePolicies_store_policies__hE_9r","footer_nav":"FooterStorePolicies_footer_nav__DLmtJ"};

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);